export const ctaSection = {
  title: "Quer nos conhecer?",
  subtitle: "Agende uma visita e descubra como podemos acompanhar o desenvolvimento do seu filho",
  bookVisit: "Reservar visita"
};
